import {
  Text,
  ListItem,
  Primary13SemiBold,
  Primary13Regular,
  UnorderedList,
  Flex
} from '@sequencehq/core-components'
import { FC } from 'react'
import { ValidationItem } from './useSteppedModal'

export const ValidationSummary: FC<{
  validation: Record<string, ValidationItem>
  validationSummaryText: string
}> = ({ validation, validationSummaryText }) => {
  return (
    <Flex gap="8px" direction="column">
      <Text>{validationSummaryText}</Text>

      <Text {...Primary13SemiBold}>To do:</Text>
      <UnorderedList>
        {Object.entries(validation).map(([validationKey, validationItem]) => (
          <ListItem key={validationKey}>
            <Text {...Primary13Regular}>{validationItem.message}</Text>
          </ListItem>
        ))}
      </UnorderedList>
    </Flex>
  )
}
